import { creators, types } from './actions'

export default {
    name: 'PicoAnalyticsModule',
    creators,
    types,
}
